var render = function render(){var _vm=this,_c=_vm._self._c;return _c('mars-view',{staticClass:"loading"},[_c('mars-view',{staticClass:"icon",style:({
        width: _vm.width,
        height: _vm.height
    })},[_c('mars-view',{staticClass:"border",style:({
            width: _vm.width,
            height: _vm.height
        })}),_c('c-icon',{style:({
            color: _vm.iconColor
        }),attrs:{"font-size":_vm.iconSize,"name":"baidu-logo"}})],1),_c('mars-view',{staticClass:"text c-font-normal c-gap-top",style:({
        color: _vm.textColor
    })},[_vm._v("\n    "+_vm._s(_vm.text)+"\n")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }